import { styled } from "styled-components";
import { grid, responsive } from "../../mixins";

export const Wrapper = styled.section`
  display: none;
  ${responsive.tablet.standard`
    display:block;
    position: fixed;
  bottom: 0;
  width: 100%;
  `}
`;

export const BottomMenue = styled.div`
  background-color: var(--background-secondary-color);
  ${grid()}
  grid-template-columns: repeat(5, 1fr);
  grid-auto-rows: 4rem;
  div {
    margin: 0 auto;
  }
  .theme-container {
    margin-top: -4rem;
  }
  .icon {
    width: 2rem;
    height: 2rem;
    color: var(--text-color);
    transition: var(--transition);
  }
  .active {
    color: var(--primary-400);
  }
`;
